jQuery(document).ready(function ($) {
	const $root = $(':root');
	let $cta = $('.bookmaker-cta').last();

	if ($cta.length === 0) {
		$cta = $('.campaign-cta').last();
	}

	const updateCtaHeight = () => {
		const ctaHeight = $cta.length ? $cta.innerHeight() : 0;
		$root.css('--cta-height', `${ctaHeight}px`, '0px');
	};

	updateCtaHeight();

	$(window).resize(updateCtaHeight);
});

document.addEventListener('DOMContentLoaded', function () {
	const el = document.querySelector('.site-main');
	const wpadminbar = document.getElementById('wpadminbar');
	const offset = wpadminbar ? Math.round(wpadminbar.offsetHeight + 68) : 68;

	window.addEventListener('scroll', function () {
		let isVisible = false;

		if (el.getBoundingClientRect().top < offset && ! isVisible) {
			document.body.classList.add('aside-is-sticky');
			isVisible = true;
		} else {
			document.body.classList.remove('aside-is-sticky');
			isVisible = false;
		}
	});
});